import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

HeadlineFive.defaultProps = {
  className: '',
}

function HeadlineFive(props: Props) {
  const { className, children } = props
  return <h5 className={classNames(style.wrapper, className)}>{children}</h5>
}

export default HeadlineFive
